import { Accordion, AttachmentCommonUpload, Card, Col, EventHandler, ImageWithFallback, InputField, Label, OutlineButton, PrimaryButton, Quantity, ReactSelectBox, Row } from "client/CommonComponents"
import permissions, { isAuthorized } from "client/utils/Permissions";
import { CONSTANTS } from "client/utils/constants";
import placeholder from "../../../../../assets/images/Placeholder.svg";
import './OrderTypeSelection.scss';
import { formatPrice, isMaxLength } from "utils";
import ManagedEquipement from "../ManagedEquipements/ManagedEquipements";
import TreeCare from "../ManagedEquipements/TreeCare";
import UtilityVehicle from "../ManagedEquipements/UtilityVehicle";
import Mower from "../ManagedEquipements/Mower";
import { useMemo, useRef } from "react";
import DealerDetails from "../ManagedEquipements/DealerDetails"; 
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import deleteItem from '../../../../../assets/images/Delete 2 New.svg';

const OrderTypeSelection = (props:any) => {

  const { vehicle, resetOnClick, searchOnClick, isItemAddedToCart } = props
    const managedEquipRef = useRef<any>([]);
    const selectedEquipmentType = () => {
      if ( vehicle?.selectedEquipementType?.text === CONSTANTS.CONSTRUCTION_EQUIPMENT || 
        vehicle?.selectedEquipementType?.text === CONSTANTS.SNOW || 
        vehicle?.selectedEquipementType?.text === CONSTANTS.STANDARIZED_EQUIPMENT || 
        vehicle?.selectedEquipementType?.text === CONSTANTS.TRAILER) {
        return <ManagedEquipement managedEquipRef={managedEquipRef} vehicle={vehicle} />
      }
      else if (vehicle?.selectedEquipementType?.text === CONSTANTS.TREE_CARE) {
        return <TreeCare managedEquipRef={managedEquipRef} vehicle={vehicle} />
      }
      else if (vehicle?.selectedEquipementType?.text === CONSTANTS.UTILITY_VEHICLE) {
        return <UtilityVehicle managedUtilityVehicleRef={managedEquipRef} vehicle={vehicle} />
      }
      else if (vehicle?.selectedEquipementType?.text === CONSTANTS.MOWER) {
        return <Mower managedMowerRef={managedEquipRef} vehicle={vehicle} />
      }
    }

    const ExpandedItemsVehicleAccordion:any = [];
  
    const ExpandedItemsVehicle =  {
        headerText:<div className={`accordion-assetHeading ${isItemAddedToCart ? "added-to-cart" : "not-added-to-cart"} `}>
          <div className="mt-1">
            <p className="accordion-heading">
               { vehicle?.requestType}
            </p>
            <p className="subText">{ vehicle?.selectedVehicleType?.label ?  vehicle?.selectedVehicleType?.label : 'Select your vehicle type' }</p>
          </div>
          <EventHandler onEvent={(e:any)=>props?.handleOnClickAttchHead(e)} data-attribute="OrderTypeSelection_Default_EventHandler">
            <div className='accordion-heading assetAttachment me-2'>
                <AttachmentCommonUpload
                  link={true}
                  list={props?.list ?? []}
                  uploadedList={props?.uploadedList ?? []}
                  setList={props?.setList}
                  multiple={true}
                  uploadBtnClick={props?.onUploadClick}
                  error={props?.error}
                  setError={props?.setError}
                  maxSize={5}
                  onRemove={props?.onRemoveClick}
                  tooltipConent={CONSTANTS.ATTACHMENTS_TOOLTIP_CONTENT}
                  iAttachmentEditable={true}
                  targetId = {`attachements-${vehicle?.requestIndex?.toString()}`}
                  isDownloadable = {false}
                  disabled={!isAuthorized(permissions.CreateUpdateBulkOrder)}
                 data-attribute="OrderTypeSelection_Default_AttachmentCommonUpload" />
            <EventHandler onEvent={props?.handleClickDeletevehicle} data-attribute="OrderTypeSelection_Default_EventHandler_2">
              <div className="up-down-image">
                <img
                  src={deleteItem}
                  alt="edit"
                  className=" editImg me-1"
                  title="Delete"
                />
              </div>
            </EventHandler>
            </div>
          </EventHandler>
        </div>,
        content: <>
          {
              <><Row className="p-3">
                  <Col xs={12} sm={12} md={4} lg={4} className='mb-3'>
                      <Label required data-attribute="OrderTypeSelection_Default_Label">Vehicle Type</Label>
                      <div className="vehicle-type-search">
                        <ReactSelectBox
                            options={props?.vehicleTypeDropdownList}
                            onChange={(item: any, e: any) => props?.vehicleTypeOnChange(e, item)}
                            name="vehicleType"
                            placeholder="Select"
                            value={vehicle?.selectedVehicleType?.label ? vehicle?.selectedVehicleType : ''}
                            className={vehicle?.selectedVehicleTypeError ? "controlValidation" : ""}
                         data-attribute="OrderTypeSelection_vehicleType_SearchSelectBox" />
                      </div>                      
                        {vehicle?.selectedVehicleTypeError && <p className='validMessage'>{vehicle?.selectedVehicleTypeError}</p>}
                  </Col>
                  {
                      props?.showVehicleDetails && vehicle?.selectedVehicleType?.hasOwnProperty('label') && <>
                      <Col xs={12} sm={12} md={4} lg={4} className='mb-3'>
                          <Label required data-attribute="OrderTypeSelection_Default_Label_2">Make</Label>
                          <ReactSelectBox
                              options={props?.makeDropdownList}
                              onChange={(item: any, e: any) => props?.makeOnChange(e, item)}
                              name="make"
                              placeholder="Select"
                              value={vehicle?.selectedMake?.label ? vehicle?.selectedMake : ''}
                              className={vehicle?.selectedMakeError ? "controlValidation" : ""}
                           data-attribute="OrderTypeSelection_make_SearchSelectBox" />
                          {vehicle?.selectedMakeError && <p className='validMessage'>{vehicle?.selectedMakeError}</p>}
                      </Col>
                      <Col xs={12} sm={12} md={4} lg={4} className='mb-3'>
                          <Label required data-attribute="OrderTypeSelection_Default_Label_3">Quantity</Label>
                          <Quantity
                            increment={props?.incrementQuantityVehicle}
                            decrement={props?.decrementQuantityVehicle}
                            value={vehicle?.quantityVehicle}
                            disableFlg={vehicle?.quantityVehicle <= 1}
                            onChange={props?.onChangeQuantityVehicle}
                            onKeyPress={(event: any) => { isMaxLength(event, 3) }}
                           data-attribute="OrderTypeSelection_Default_Quantity" />
                          {vehicle?.quantityVehicleError && <p className='validMessage'>{vehicle?.quantityVehicleError}</p>}
                      </Col>
                      <Col xs={12} sm={12} md={8} lg={8} className='mb-3'>
                          <Label required data-attribute="OrderTypeSelection_Default_Label_4">Vehicle Spec</Label>
                          <ReactSelectBox
                              options={props?.vehicleSpecDropdownList}
                              onChange={(item: any, e: any) => props?.vehicleSpecOnChange(e, item)}
                              name="vehicleSpec"
                              placeholder="Select"
                              value={vehicle?.selectedSpec?.label ? vehicle?.selectedSpec : ''}
                              className={vehicle?.selectedSpecError ? "controlValidation" : ""}
                           data-attribute="OrderTypeSelection_vehicleSpec_SearchSelectBox" />
                          {vehicle?.selectedSpecError && <p className='validMessage'>{vehicle?.selectedSpecError}</p>}
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12} className='mb-3'>
                          <Label data-attribute="OrderTypeSelection_Default_Label_5">Comments</Label>
                          <InputField 
                          placeholder='Please enter more information about the asset'
                          multiline={true} 
                          resizable={false} 
                          className={vehicle?.commentError ? "comment-block controlValidation" : "comment-block"}
                          value={vehicle?.comment}
                          onChange={props?.onChangeCommentehicle}
                           data-attribute="OrderTypeSelection_Default_Input" />
                          {vehicle?.commentError && <p className='validMessage'>{vehicle?.commentError}</p>}
                      </Col>
                    </>
                  }                                           
                  <div>
          <PrimaryButton
            text={props?.isItemAddedToCart ? 'Update to Cart' : 'Add to Cart'}
            className='pull-right'
            onClick={props?.handleAddClick}
            disabled={!isAuthorized(permissions?.CreateUpdateBulkOrder)}
           data-attribute="OrderTypeSelection_Default_Button" />
          <OutlineButton
            text='Reset'
            className='me-2 pull-right'
            onClick={props?.handleResetClickVehicle}
            disabled={!isAuthorized(permissions?.CreateUpdateBulkOrder)}
           data-attribute="OrderTypeSelection_Default_Button_2" />                     
                  </div>                   
              </Row>               
              </>
          } 
        </>,
        uuid: "order-type-selection-accordion",
      }

  const ExpandedNoNAPItems: any = useMemo(() => {
    const noNAPItems: any = []
    vehicle?.selectedCatalogItems?.map((catalogItem: any) => {
      if (catalogItem?.managedEquipmentDealer?.hasOwnProperty('managedEquipmentDealerQuotePriceId')) {
        noNAPItems?.push({
          headerText: <div className="accordion-assetHeading">
              <p className="accordion-heading">
                {catalogItem?.description}
              </p>
          </div>,
          content: <DealerDetails requestIndex={vehicle?.requestIndex} catalogItem={catalogItem} plannedRef={props.plannedRef} />,
          uuid: "order-type-selection-accordion",
        })
      }
    })
    return noNAPItems
  }, [vehicle])

    const ExpandedItemsManagedEquip =  
      {
        headerText:<div className={`accordion-assetHeading ${isItemAddedToCart ? "added-to-cart" : "not-added-to-cart"} `}>
          <div className="mt-1">
            <p className="accordion-heading">
               {CONSTANTS.MANAGED_EQUIPMENT}
            </p>
            <p className="subText">{ props?.vehicle?.selectedEquipementType?.label ? props?.vehicle?.selectedEquipementType?.label :'Select your equipment type'}</p>
          </div>
          <EventHandler onEvent={(e:any)=>props?.handleOnClickAttchHead(e)} data-attribute="OrderTypeSelection_Default_EventHandler_3">
            <div className={`accordion-heading assetAttachment me-2 ${vehicle?.attachmentError ? 'mt-0' : ''}`}>
                <div className={`attach-block ${vehicle?.attachmentError ? 'attach-error' :''}`}>
                  <AttachmentCommonUpload
                    link={true}
                    list={props?.list}
                    isAttachmentsRequired={props?.isAttachmentsRequired}
                    uploadedList={props?.uploadedList}
                    setList={props?.setList}
                    multiple={true}
                    uploadBtnClick={props?.onUploadClick}
                    error={props?.error}
                    setError={props?.setError}
                    maxSize={5}
                    onRemove={props?.onRemoveClick}
                    tooltipConent={CONSTANTS.ATTACHMENTS_TOOLTIP_CONTENT}
                    iAttachmentEditable={true}
                    targetId = {`attachements-${vehicle?.requestIndex?.toString()}`}
                    isDownloadable = {false}
                    disabled={!isAuthorized(permissions.CreateUpdateBulkOrder)}
                   data-attribute="OrderTypeSelection_Default_AttachmentCommonUpload_2" />
                  <p className="validMessage responsiveMessage mt-0">{vehicle?.attachmentError}</p>
                </div>           
                <EventHandler onEvent={props?.handleClickDeleteEquipment} data-attribute="OrderTypeSelection_Default_EventHandler_4">
                  <div className="up-down-image">
                    <img
                      src={deleteItem}
                      alt="edit"
                      className=" editImg me-1"
                      title="Delete"
                    />
                  </div>
                </EventHandler>
            </div>
          </EventHandler>
        </div>,
        content: <div className="catalog-block my-0 p-3">
          {
              <><Row>
                <Col xs={12} sm={12} md={4} lg={4} className='mb-3'>
                      <Label required data-attribute="OrderTypeSelection_Default_Label_6">Equipment Type</Label>                      
                      <div className="vehicle-type-search">
                        <ReactSelectBox
                            options={props?.equipmentTypeDropdownList}
                            placeholder="Select"
                            onChange={(item: any, e: any) => props?.equipmentTypeOnChange(e, item)}
                            name="equipmentType"
                            value={vehicle?.selectedEquipementType?.hasOwnProperty("label") ? vehicle?.selectedEquipementType : ""}
                            className={vehicle?.selectedEquipementTypeError?.length ? 'controlValidation' : ""}
                         data-attribute="OrderTypeSelection_equipmentType_SearchSelectBox" />
                      </div>    
                      {vehicle?.selectedEquipementTypeError ? <p className='validMessage'>{vehicle?.selectedEquipementTypeError}</p> : null}                  
                  </Col>
                  { props?.showManagedEquipDetails ? <> {selectedEquipmentType()} </> : null}
                  <Col xs={12} sm={12} md={12} lg={12} className='mt-0 mb-0'>
                    <div className='pull-right'>
                      <OutlineButton text='Reset' onClick={resetOnClick}  data-attribute="OrderTypeSelection_Default_Button_3" />
                      <PrimaryButton text='Search' onClick={searchOnClick} btnRef={(element: any) => managedEquipRef.current[9] = element}  data-attribute="OrderTypeSelection_Default_Button_4" />
                    </div>
                  </Col>
               { props?.showManagedEquipDetails ? <>
               <>{props?.catalogItemDetails?.length ? <p className="catalog-head">Total Items <span className="required">*</span>({props?.catalogItemDetails?.length})</p> : null}</>
                  <div className="clearfix catelog-item-wrapper">
                    {props?.catalogItemDetails?.map((item: any, _index: any) => {
                      return (
                        <EventHandler onEvent={() => item.price > 0 && props.handleCardClick(item)} data-attribute={`OrderTypeSelection_${(item?.description || _index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                          <div
                            key={_index}
                            className={`catelog-card ${item?.isSelected ? "active" : ""} ${!item?.price ? "disable-card" : ""}`}
                          >
                            <div className="vehicledetail-section">
                              <div className="vehicle-image">
                                <ImageWithFallback src={item.imagePath} alt="vehicle" fallbackSrc={placeholder}  data-attribute="OrderTypeSelection_Default_ImageWithFallback" />
                              </div>
                              <div className="vehicle-specification bulk-order">
                                <p className="vehicle-model" title={item.description}>{item.description}</p>
                              </div>
                              <div className="design-ratings">
                                <div className="selected-card">
                                  <span className="selected-catalog"></span>
                                </div>
                              </div>
                              {!item.price && <span className='validMessage centerMessage'>This selection is not available for bulk order</span>}
                            </div>
                            
                            <div className="vehicleprice-section">
                              <div className="price-section">
                                <p>Price</p>
                                <span><b>{item.price ? `$${formatPrice(item.price, 2)}` : "N/A"}</b></span>
                              </div>
                                <div className="monthy-expenses">
                                  <Quantity
                                    increment={(e:any)=> props?.incrementQuantityManagedEquipment(e, item)}
                                    decrement={(e:any)=> props?.decrementQuantityManagedEquipment(e, item)}
                                    value={item?.quantity}
                                    onChange={(e:any) => props?.onChangeQuantitymanagedEquipment(e, item)}
                                    disableFlg={item?.quantity <= 1}
                                    onKeyPress={(event: any) => { isMaxLength(event, 3) }}
                                    disable={item?.price <= 0}
                                    disabledQuantity = {item?.price <= 0}
                                   data-attribute="OrderTypeSelection_Default_Quantity_2" />
                                  <div className='validMessage'>{item?.quantityError}</div>
                                </div>
                            </div>
                          </div>
                        </EventHandler>
                      );
                    })}
                  </div>                  
                  </> : ''}                  
              </Row>
              {ExpandedNoNAPItems?.length > 0 &&
                <Row className="mt-4">

                  <Accordion
                    Items={ExpandedNoNAPItems}
                    preExpanded={['order-type-selection-accordion']}
                    className={`order-type-selection-accordion`}
                    allowZeroExpanded={true}
                   data-attribute="OrderTypeSelection_Default_Accordion" />
                </Row>
              }
              <Row>
                  <div>
                   {props?.catalogItemDetails?.length ? (
                     <PrimaryButton
                       text={props?.isItemAddedToCart ? "Update to Cart" : "Add to Cart"}
                       className='pull-right mt-2'
                       onClick={props?.handleAddClick}
                       disabled={!isAuthorized(permissions?.CreateUpdateBulkOrder)}
                      data-attribute="OrderTypeSelection_Default_Button_5" />
                   ) : null}
                  </div>
              </Row>
              </>
          } 
        </div>,
        uuid: "order-type-selection-accordion",
      };

    
  if (vehicle?.requestType === CONSTANTS?.VEHICLE_REQUEST) {
    ExpandedItemsVehicleAccordion?.push(ExpandedItemsVehicle)
  } else {
    ExpandedItemsVehicleAccordion?.push(ExpandedItemsManagedEquip)
  }
    

  return (<>
    {
      <div className="vehicle-block"><Card data-attribute="OrderTypeSelection_Default_Card">
        <Accordion
          Items={ExpandedItemsVehicleAccordion}
          preExpanded={['order-type-selection-accordion']}
          className={`order-type-selection-accordion`}
          allowZeroExpanded={true}
         data-attribute="OrderTypeSelection_Default_Accordion_2" />
      </Card></div>
    }
    <CancelConfirmationPopup
      hideDialog={!props?.Popupcontent.isDialogVisible}
      onDismiss={props?.hideDialog}
      Popupcontent={props?.Popupcontent}
      popupOutlinebtnOnclick={() => props?.Popupcontent.popupOutlinebtnOnclick()}
      popupPrimarybtnOnclick={() => props?.Popupcontent.popupPrimarybtnOnclick()}
    />
  </>)
}

export default OrderTypeSelection
